<template>
  <div class="input-time">
    <input v-model="state.hours" type="number" min="0" /> t
    <input v-model="state.minutes" type="number" min="0" /> m
    <input v-model="state.seconds" type="number" min="0" /> s
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, watch } from 'vue'

export default defineComponent({
  name: 'InputTime',
  emits: ['update:modelValue'],
  props: {
    modelValue: Number // seconds
  },
  setup(props, { emit }) {   

    const d = new Date((props.modelValue || 0) * 60 * 1000)

    const state = reactive({
      hours: d.getHours() - 1,
      minutes: d.getMinutes(),
      seconds: d.getSeconds()
    })

    watch(() => state, (newTime) => {
      emit('update:modelValue', newTime)
    })

    return { state }
  }
})
</script>

<style lang='scss' scoped>
.input-time {
  input {
    max-width: 4rem;
  }
}
</style>
